import { createContext, useReducer, useContext, Dispatch, ReactNode } from 'react';
import { IPageStatus, ITimeLine, IProductItem, IUserLevelInfo } from './type';

interface MemberProtocolItem {
    title: string;
    line: string[];
}

interface MemberProtocol {
    [IPageStatus.TEASER]: MemberProtocolItem[];
    [IPageStatus.ACTIVITY]: MemberProtocolItem[];
}

interface MonthlyState {
    timeLine: ITimeLine | null;
    isLogin: boolean;
    rewardUserInfo: any;
    rewardUserLevel: IUserLevelInfo | null;
    pageStatus: IPageStatus;
    protocol: MemberProtocol;
    secKillisBegin: boolean; // 秒杀是否开始
    secKillProduct: IProductItem[];
    localDebugTime?: string;
}

type MonthlyAction = {
    type: string;
    payload: any;
};

const initState: MonthlyState = {
    pageStatus: IPageStatus.TEASER,
    timeLine: null,
    isLogin: false,
    rewardUserInfo: {},
    rewardUserLevel: null,
    protocol: {
        [IPageStatus.TEASER]: [],
        [IPageStatus.ACTIVITY]: [],
    },
    secKillisBegin: false,
    secKillProduct: [],
    localDebugTime: undefined,
};

const fsReducer = (state: MonthlyState, action: MonthlyAction): MonthlyState => {
    const { type, payload } = action;
    switch (type) {
        case 'changePageStatus':
            return { ...state, pageStatus: payload };
        case 'changeRewardUserInfo':
            return { ...state, rewardUserInfo: payload };
        case 'changeRewardUserLevel':
            return { ...state, rewardUserLevel: payload };
        case 'changeSecKillisBegin':
            return { ...state, secKillisBegin: payload };
        case 'changeSecKillProduct':
            return { ...state, secKillProduct: payload };
        default:
            return state;
    }
};

export const MonthlyContext = createContext<{ state: MonthlyState; dispatch: Dispatch<MonthlyAction> }>({
    state: initState,
    dispatch: () => null,
});

export function MonthlyProvider({ children, ...props }: { children: ReactNode; state?: any }) {
    const [state, dispatch] = useReducer(fsReducer, Object.assign(initState, props.state || {}));
    return <MonthlyContext.Provider value={{ state, dispatch }}>{children}</MonthlyContext.Provider>;
}

export const useMonthlyStore = () => {
    const store = useContext(MonthlyContext);
    return store.state;
};

export const useMonthlyDispatch = () => {
    const store = useContext(MonthlyContext);
    return store.dispatch;
};
